<template>
  <div class="flex h-[302px] w-[134px] flex-col gap-2 overflow-y-auto pr-2">
    <button
      v-for="shortcut in shortcutPresets"
      :key="shortcut.label"
      class="bg-ontick-steel-500 hover:bg-ontick-blue-800 w-full rounded py-1.5 text-xs transition-all"
      @click="setRange(shortcut.value, shortcut.event)"
    >
      {{ shortcut.label }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    range: {
      type: Boolean,
    },
    allowPast: {
      type: Boolean,
    },
    allowFuture: {
      type: Boolean,
    },
    allowWeekends: {
      type: Boolean,
    },
  },

  computed: {
    shortcutPresets() {
      return [
        {
          label: "Hoje",
          value: {
            start: this.moment().startOf("day"),
            end: this.moment().endOf("day"),
          },
          event: "current-month",
        },
        {
          label: "Essa semana",
          // value: {
          //   start: this.moment().startOf("week").day(1),
          //   end: this.moment(),
          // },
          value: this.validDate({
            start: this.moment().startOf("week"),
            end: this.moment(),
          }),
          event: "current-year",
        },
        {
          label: "Semana anterior",
          value: this.validDate({
            start: this.moment().subtract(1, "week").startOf("week").day(1),
            end: this.moment().subtract(1, "week").endOf("week").day(5),
          }),
          event: this.isPreviousMonth(
            this.validDate({
              start: this.moment().subtract(1, "week").startOf("week").day(1),
              end: this.moment().subtract(1, "week").endOf("week").day(5),
            }).start
          ),
        },
        {
          label: "Últimos 7 dias",
          value: this.validDate({
            start: this.moment().subtract(7, "days").startOf("day"),
            end: this.moment(),
          }),
        },
        {
          label: "Esse mês",
          value: this.validDate({
            start: this.moment().startOf("month"),
            end: this.moment(),
          }),
          event: "current-month",
        },
        {
          label: "Mês anterior",
          value: this.validDate({
            start: this.moment().subtract(1, "month").startOf("month"),
            end: this.moment().subtract(1, "month").endOf("month"),
          }),
          event: "previous-month",
        },
        {
          label: "Últimos 30 dias",
          value: this.validDate({
            start: this.moment().subtract(30, "days").startOf("day"),
            end: this.moment(),
          }),
        },
        {
          label: "Esse ano",
          value: this.validDate({
            start: this.moment().startOf("year"),
            end: this.moment(),
          }),
        },
        {
          label: "Ano anterior",
          value: this.validDate({
            start: this.moment().subtract(1, "years").startOf("year"),
            end: this.moment().subtract(1, "years").endOf("year"),
          }),
          event: "previous-year",
        },
        {
          label: "Últimos 365 dias",
          value: this.validDate({
            start: this.moment().subtract(365, "days").startOf("day"),
            end: this.moment(),
          }),
          event: "current-month",
        },
      ];
    },
  },

  methods: {
    // isWeekday(moment) {
    //   return ![0, 6].includes(this.moment(moment).day());
    // },
    validDate({ start, end }) {
      let obj = {};
      if (this.moment(start).day() === 0) {
        obj.start = this.moment(start).day(1);
      } else {
        obj.start = start;
      }
      if (this.moment(end).day() === 6) {
        obj.end = this.moment(end).day(5);
      } else {
        obj.end = end;
      }
      return obj;
    },
    setRange(range, event) {
      this.$emit("set-range", range);
      if (event) {
        this.$emit(event);
      }
    },
    isPreviousMonth(moment) {
      if (this.moment(moment).month() === this.moment().month() - 1) {
        return "previous-month";
      }
    },
  },
};
</script>

<style></style>
